import axios from "axios";

const baseURL =
  process.env
    .REACT_APP_API_URL; /* 'https://server2.factorymaker.at' */ /* process.env.REACT_APP_API_URL */
const baseURLTest = "https://bulldog-perfect-kindly.ngrok-free.app";

const axiosConfig = {
  baseURL: baseURL,
  /* headers: {
    "ngrok-skip-browser-warning": "true",
  }, */
};

export const axiosInstance = axios.create(axiosConfig);

axiosInstance.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  const companyId = localStorage.getItem("companyId");

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  if (companyId) {
    config.headers["company-id"] = companyId;
  }

  return config;
});

export function isAxiosApiError(err) {
  return (
    typeof err === "object" &&
    err !== null &&
    "isAxiosError" in err &&
    err.isAxiosError === true
  );
}
